import { GeneralThemeFormValues } from './generalTheme.types';

export const defaultGeneralTheme: GeneralThemeFormValues = {
  storeTabName: 'Royal Blast Store',
  logo: 'https://media.appcharge.com/defaults/default-store-logo.svg',
  favicon: 'https://media.appcharge.com/defaults/default-store-logo.svg',
  backgroundImageMobile:
    'https://media-dev.appcharge.com/media/defaults/Default_Appcharge_Background_Mobile.jpeg',
  backgroundImageDesktop:
    'https://media-dev.appcharge.com/media/defaults/Default_Appcharge_Background_Desktop.jpeg',
  storeSaleImage: '',
  loaderAnimation:
    'https://media-dev.appcharge.com/media/defaults/circular-loader.json',
  font: 'montserrat',
  receiptHeader: '',
  logoSize: 'medium',
  popupRatio: '16:9',
  footer: {
    imageMobile: '',
    imageDesktop: '',
    appstoreLink: '',
    googlePlayLink: '',
    privacyPolicyUrl: '',
    termsAndConditionsUrl: '',
    supportLink: '',
    supportParams: {
      playerIdParamName: '',
      playerNameParamName: ''
    },
    openLinksInNewTab: false,
    showCookieSettings: false
  },
  maintenanceModeRichText: {
    text: "We're currently performing maintenance. Please check back soon.",
    fontColor: 'rgb(0, 0, 0)'
  },
};
